import { apiRoutes } from '@features/campaigns/performance/consts/apiRoutes.ts';
import { AISummaryType } from '@features/campaigns/performance/types/performance.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { CampaignId } from '@shared/types/campaign.ts';

// Summary language is sent via the global `x-user-lang` header (see AxiosConfig)
export async function generateAISummary(campaignId: CampaignId): Promise<AISummaryType | null> {
  return await apiClient.post<undefined, AISummaryType | null>(apiRoutes.generateAISummary(campaignId));
}
